<template>
  <SButton
    variant="outline"
    size="sm"
    class="w-full cursor-pointer disabled:cursor-not-allowed"
    data-cy="select-order-button"
    @click="onClick"
  >
    {{ $t("button.edit-order") }}
  </SButton>
</template>

<script setup lang="ts">
import { SButton } from "@smeetz/ui-core";

import { openOrderFromTable } from "@/utils/vue-helpers/orders";
import type { IParsedOrder } from "@/interfaces/store/IOrder";

const props = defineProps<{ row: Record<string, unknown> }>();

/**
 * Hand off to the shared order-click flow.
 *
 * @returns {boolean} Sentinel.
 */
function onClick(): boolean {
  openOrderFromTable(props.row as unknown as IParsedOrder);

  return true;
}
</script>
